import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { BrandPicto } from '@ecm/material';
import { LinkSyncPipe } from '@ecm/router';

import { CarrouselItemViewModel } from '../../business/model/carrousel-item.view-model';
import { CarrouselNavigationItemViewModel } from '../../business/model/carrousel-navigation-item.view-model';
import { CarrouselOfferItemViewModel } from '../../business/model/carrousel-offer-item.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';

@Component({
    selector: 'ecm-carrousel-nav',
    templateUrl: 'carrousel-nav-accordion.component.html',
    styleUrls: ['carrousel-nav-accordion.component.css'],
    standalone: true,
    imports: [CommonModule, NgbModule, TranslateModule, LinkSyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrouselNavAccordionComponent implements OnInit {
    @Input() public item: CarrouselOfferItemViewModel;
    @Input() public index: string | number;
    @Input() public carrouselItem: CarrouselItemViewModel;
    @Input() public selectedLink: string;
    @Input() public carrouselLinksItemsSelected: boolean;
    @Input() public isSosh: boolean;

    private readonly router = inject(Router);

    public e2e = 'e2e-carrousel-nav-';
    public selectedUsageCode = signal<string | null>(null);

    public getIcon = computed(() => {
        if (this.item.brand === 'Orange' && this.isSosh) {
            return BrandPicto.ORANGE;
        }
        if (this.item.brand === 'Sosh' && !this.isSosh) {
            return BrandPicto.SOSH;
        }
    });

    public encodedCurrentItemId: string;
    public reverseBrandLogoUrl: string;

    public constructor(
        protected route: ActivatedRoute,
        private carrouselStore: CarrouselStoreService,
    ) {}

    public ngOnInit() {
        this.setSelectedNavItem();
        this.encodedCurrentItemId = btoa(this.item.cid);
    }

    public select(cid: string) {
        if (cid) {
            this.carrouselStore.selectItem(cid);
        }
        this.carrouselItem.button.navigationExtras.queryParams.carrousel = this.encodedCurrentItemId;
        this.carrouselItem.button.params.set('carrousel', this.encodedCurrentItemId);
        this.carrouselStore.openLink(this.carrouselItem.button);
    }

    public openLink(navItem: CarrouselNavigationItemViewModel) {
        if (['MULTISIMI', 'MULTISIMIA'].includes(this.selectedLink.toUpperCase())) {
            this.selectedUsageCode.set(navItem.usageCode);
        }
        this.carrouselStore.openLink(navItem.button);
    }

    //Simple (but ugly) solution to know wich multisim of the same type is selected
    private setSelectedNavItem() {
        if (['MULTISIMI', 'MULTISIMIA'].includes(this.selectedLink.toUpperCase())) {
            const urlChunks = this.router.url.split('/');
            const usageCodeIdx = urlChunks.findIndex((chunk) => chunk === 'multi-sim') - 1;
            this.selectedUsageCode.set(urlChunks[usageCodeIdx]);
        }
    }
}
